import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInMemoryStorage } from '@ocx/data-in-memory-storage';

import { AppRoutePath } from '../../pages/AppRoutePath';
import { AUTH_RETURN_URL_STORAGE_KEY } from './return-url.storage';

export const useNavigateAfterSignIn = () => {
  const navigate = useNavigate();
  const { value: returnUrl, eraseStorageValue: eraseReturnUrl } =
    useInMemoryStorage<string>(AUTH_RETURN_URL_STORAGE_KEY);

  return useCallback(() => {
    if (returnUrl) {
      eraseReturnUrl();
      navigate(returnUrl, { replace: true });
    } else {
      navigate(AppRoutePath.Home, { replace: true });
    }
  }, [navigate, returnUrl, eraseReturnUrl]);
};
